import React from 'react';
import { toast } from 'react-toastify';
import api from '../../ApiService';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button as PrimeButton } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

import { ModalOKCancel } from '../../modals';

export default class Lookup extends React.Component {
    constructor(props) {
        super(props);

        this.removeItem = this.removeItem.bind(this);
        this.editTemplate = this.editTemplate.bind(this);
        this.onEditorValueChange = this.onEditorValueChange.bind(this);

        this.state = {
            items: [],
            fields: [],
            isDirty: false,

            showCancelModal: false
        };
    }

    componentDidMount = async () => {
        let items = await api.getLookup(this.props.lookupName);
        let fields = await api.getLookupEditableFields(this.props.lookupName);
        this.setState({ items, fields });
    }

    onClickCancel = async (e) => {
        e.preventDefault();

        if (!this.state.isDirty) {
            await this.onConfirmCancel();
            return;
        }
        else {
            this.setState({ showCancelModal: true });
        }
    }

    onConfirmCancel = async (e) => {
        // reload from server
        let items = await api.getLookup(this.props.lookupName);
        let fields = await api.getLookupEditableFields(this.props.lookupName);
        this.setState({ items, fields, isDirty: false });
        toast.success("Changes canceled.");
    }

    onClickSave = async () => {
        let err = await api.saveLookup(this.props.lookupName, this.state.items);
        if (err) {
            toast.error(`Unable to update ${this.props.lookupName}. ${err}`, { autoClose: 7000 });
        }
        else {
            let items = await api.getLookup(this.props.lookupName);
            let fields = await api.getLookupEditableFields(this.props.lookupName);
            this.setState({ items, fields, isDirty: false });
            toast.success(`${this.props.lookupName} updated.`);
        }
    }

    onEditorValueChange = (e) => {
        // just set the dirty flag
        if (!this.state.isDirty) this.setState({ isDirty: true });
    }

    onEditorBlur = (e, props) => {
        if (e.target.defaultValue === e.target.value) return;

        let items = [...props.value];
        if (items[props.rowIndex][props.field] !== e.target.value) {
            items[props.rowIndex][props.field] = e.target.value;
            this.setState({ items });
        }
    }

    onEditorKeyPress = (e, props) => {
        // have to manually handle this since onBlur doesn't make it to our control
        // yes, i'm a little upset about that
        // 9 - tab
        // 13- enter
        if (e.keyCode === 9 || e.keyCode === 13) {
            this.onEditorBlur(e, props);
        }
    }

    addItem = () => {
        // Check to see if there is already an empty one at the end
        if (this.state.items.length === 0 || this.state.items[this.state.items.length - 1].name !== '') {
            let items = this.state.items;
            let index = items.length;
            items[index] = { id: 0, name: '', index };
            this.setState({ items, isDirty: true });

            setTimeout(() => {
                let nodes = Array.from(document.getElementsByClassName('p-editable-column'));
                let columns = nodes.filter(div => div.innerText === '');
                if (this.state.fields.length === 1) {
                    columns[0].click();
                }
                else {
                    columns[columns.length - this.state.fields.length + 1].click();
                }
            }, 200);
        }
        window.scrollTo(0, 9999);
    }

    removeItem = (e, rowData) => {
        if (rowData.index) {
            // this item was just added
            // (yes, i am being tricky with the var)
            var items = this.state.items.filter(x => x.index !== rowData.index);
        }
        else {
            items = this.state.items.filter(x => x.id !== rowData.id);
        }
        this.setState({ items, isDirty: true });
    }

    editTemplate = (props) => {
        return (
            <InputText type='text' defaultValue={props.rowData[props.field]}
                onBlur={(e) => this.onEditorBlur(e, props)}
                onChange={(e) => this.onEditorValueChange(e)}
                onKeyDown={(e) => this.onEditorKeyPress(e, props)}
            />
        );
    }

    actionTemplate = (rowData, column) => {
        return (
            <div>
                <PrimeButton type="button" icon="pi pi-trash" className="p-button-danger"
                    disabled={rowData.usage > 0} title={rowData.usage > 0 ? `Used by ${rowData.usage} ${rowData.usageContext ? rowData.usageContext : 'hospitals'}.` : ''}
                    onClick={(e) => this.removeItem(e, rowData)}
                />
            </div>
        );
    }

    addButton = () => {
        return (
            <div>
                <PrimeButton type="button" icon="pi pi-plus" className="p-button-info" onClick={this.addItem} />
            </div>
        );
    }

    renderSaveCancel = (columnSpread) => {
        return (
            <Grid item xs={columnSpread} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }} >
                <Button variant='contained' color='default' style={{ marginRight: '15px', width: '80px' }} onClick={this.onClickCancel} disabled={!this.state.isDirty}>Cancel</Button>
                <Button variant='contained' color='primary' style={{ width: '80px' }} onClick={this.onClickSave} disabled={!this.state.isDirty}>Save</Button>
            </Grid>
        );
    }

    onRowReorder = (e) => {
        this.setState({ items: e.value, isDirty: true });
    }

    renderCancelModal = () => {
        return (
            <ModalOKCancel
                title={"Discard changes"}
                body={"You have unsaved changes. Click OK to discard your changes."}
                show={this.state.showCancelModal}
                onOK={() => { this.onConfirmCancel(); this.setState({ showCancelModal: false }); }}
                onCancel={() => this.setState({ showCancelModal: false })}
            />
        );
    }

    onIsActiveChange = (e, rowIndex) => {
        let items = this.state.items.slice();
        items[rowIndex].excludeEmail = e.target.checked;

        this.setState({
            isDirty: true,
            items
        });
    }

    isActiveTemplate = (rowData, props) => {
        return (
            <Checkbox
                checked={rowData.excludeEmail}
                onChange={(e) => this.onIsActiveChange(e, props.rowIndex)}
                value={`items[${props.rowIndex}.excludeEmail`}
                color="primary"
            />
        );
    }

    render() {
        if (this.state.fields.length === 0) {
            return <div>Loading...</div>;
        }
        // Dynamically build set of columns based on set of editable fields. Include sort and action columns.
        let columns = [];
        let isSortable = this.state.fields.find((value) => value.key === "sortOrder") ? true : false;

        let columnOffset = 0;
        if (isSortable) {
            columnOffset++;
            columns.push(<Column key='lookupEditorField0' header='Order' rowReorder style={{ width: '6em', textAlign: 'center' }} />);
        }

        let mapped = this.state.fields.filter((field) => field.key !== "sortOrder").map((field, i) => {
            if (field.key === 'excludeEmail') {
                return <Column key={`lookupEditorField${i + columnOffset}`} field={field.key} header={field.value} body={this.isActiveTemplate} style={{ textAlign: 'center', width: '17%' }} />;
            } else {
                return <Column key={`lookupEditorField${i + columnOffset}`} field={field.key} header={field.value} editor={this.editTemplate} />;
            }
        });
        for (let i = 0; i < mapped.length; i++) {
            columns.push(mapped[i]);
        }
        let lastColumnIndex = this.state.fields.length;

        columns.push(<Column key={`lookupEditorField${lastColumnIndex}`} body={this.actionTemplate} header={this.addButton()} style={{ textAlign: 'center', width: '6em' }} />);

        let onRowReorder = isSortable ? this.onRowReorder : undefined;
        return (
            <div>
                <Grid container style={{ paddingBottom: '10px' }}>
                    <Grid item xs={3}>
                        <h3>{this.props.lookupName}</h3>
                    </Grid>
                    {this.renderSaveCancel(9)}
                </Grid>
                <div style={{ paddingBottom: '10px' }}>
                    <DataTable value={this.state.items} reorderableRows={isSortable} onRowReorder={onRowReorder}>
                        {columns}
                    </DataTable>
                </div>
                {this.renderSaveCancel(12)}
                <br />
                <br />

                {this.renderCancelModal()}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Admin/Lookup.js